import logger from '@greenlight/logger';
import get from 'lodash/get';
import { storageAvailable } from '../helpers';

const mapper = (action, store) => {
  const isWRIA = get(store.getState(), 'app.embeddedWebreg', false);
  let phoneNumber;

  if (storageAvailable('sessionStorage')) {
    phoneNumber = sessionStorage.getItem('tempPhoneNumber');
  }

  if (action.type === 'GET_USER_FAILURE') {
    if (!isWRIA) {
      // If we're in WRIA, another middleware will take care of the issue.
      if (storageAvailable('sessionStorage')) {
        sessionStorage.clear();
      }
      if (phoneNumber) {
        window.location = `/?phoneNumber=${phoneNumber}`;
      } else {
        window.location = '/';
      }
    }
  }

  if (action.type === 'GET_MICRODEPOSITS_SUCCESS') {
    if (action.payload.data) {
      logger.info(
        `Microdeposit amount 1: ${action.payload.data.microAmount1}. Microdeposit amount 2: ${action.payload.data.microAmount2}.`
      );
    }
  }
};

const Middleware = store => next => action => {
  mapper(action, store);
  next(action);
};

export default Middleware;
